export default ($) => {

    $('.elementor-widget-eael-gravity select').each((indexSelect, selectGravity) => {

        $(selectGravity).select2({
            minimumResultsForSearch: Infinity,
            dropdownCssClass: 'select2-content-dropdown',
            dropdownParent: $(selectGravity).parent(),
            dropdownAutoWidth: true,
        });
    })
}